<template>
	<div class="container-fluid no-padding-sides">
		<div class="container">
			<div class="row">
				<div class="col-sm-2 no-padding-top">
					<h2 class="no-padding-bottom">Contáctanos</h2>
				</div>
			</div>
		</div>
		<div id="contacto" class="container">
			<aside class="col-sm-3">
				<address>
					<span class="fa-stack fa-lg">
						<i class="fa fa-circle fa-stack-2x"></i>
						<i class="fa fa-whatsapp fa-stack-1x fa-inverse" aria-hidden="true"></i>
					</span>
					<strong>WhatsApp</strong>
					<p class="text-gray-sm">
					<a href="https://wa.me/523327482493" target="_blank" class="text-gray-sm">
						(33) 2748 2493
					</a>
					</p><br>
				</address>
				<address>
					 <span class="fa-stack fa-lg">
						<i class="fa fa-circle fa-stack-2x"></i>
						<i class="fa fa-envelope fa-stack-1x fa-inverse"></i>
					</span>
					<strong>Email</strong>
					<p class="text-gray-sm">
						hola@lasddi.com
					</p><br>
				</address>
				<address>
					<span class="fa-stack fa-lg">
						<i class="fa fa-circle fa-stack-2x"></i>
						<i class="fa fa-clock-o fa-stack-1x fa-inverse"></i>
					</span>
					<strong>Horarios</strong>
					<p class="text-gray-sm">
						Lun a Vie de 10am a 7pm
					</p>
				</address>
			</aside>

			<section id="mensaje">
				<div class="col-sm-8 col-sm-offset-1">
					<form class="form-horizontal" @submit="sendEmailContact">
						<div class="form-group">
							<div class="col-sm-6 padding-bottom-sm">
								<input type="text" class="form-control" :class="{ 'has-error': err.name || err.name_msg }" id="phone" placeholder="Nombre" v-model="form.name">
								<div class="tooltip-error" v-if="err.name">
									<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
									Ingresa tu nombre para continuar.
								</div>
								<div class="tooltip-error" v-if="err.name_msg">
									<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
									{{ err.name_msg }}
								</div>
							</div>
							<div class="col-sm-6">
								<input type="text" class="form-control" :class="{ 'has-error': err.email || err.email_msg}" id="email" placeholder="Email" v-model="form.email">
								<div class="tooltip-error" v-if="err.email">
									<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
									Ingresa tu email para continuar.
								</div>
								<div class="tooltip-error" v-if="err.email_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.email_msg }}
						      	</div>
							</div>
						</div>

						<div class="form-group" style="margin-left: 0">
							<div class="col-sm-12 padding-right-xs padding-bottom-sm">
								<input type="text" class="form-control" :class="{ 'has-error': err.phone || err.phone_msg }" id="phone" placeholder="Telefono" v-model="form.phone">
								<div class="tooltip-error" v-if="err.phone">
									<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
									Ingresa tu nombre para continuar.
								</div>
								<div class="tooltip-error" v-if="err.phone_msg">
									<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
									{{ err.phone_msg }}
								</div>
							</div>
						</div>

						<div class="form-group" style="margin-left: 0">
							<div class="col-sm-12 padding-right-xs">
								<div class="form-control control-select" :class="{ 'has-error': err.subject }">
									<select name="asunto" class="select" id="asunto" v-model="form.subject">
										<option value="" disabled selected>Asunto</option>
										<option value="1">Agendar una cita sobre un producto</option>
										<option value="2">Sobre un producto</option>
										<option value="3">Consulta general</option>
										<option value="4">Seguimiento de mi pedido</option>
										<option value="5">Soy Proveedor</option>
									</select>
									<i class="fa fa-caret-down select-caret"></i>
								</div>


								<div class="tooltip-error" v-if="err.subject">
									<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
									Ingresa un asunto para continuar.
								</div>
							</div>
						</div>
						<div class="form-group">
							<div class="col-sm-12 padding-right-sm" style="padding-top: 3px">
								<textarea class="form-control" :class="{ 'has-error': err.msg || err.msg_msg}" rows="13" id="comment" placeholder="Añade tu mensaje" v-model="form.msg"></textarea>
								<div class="tooltip-error" v-if="err.msg">
									<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
									Ingresa tu mensaje para continuar.
								</div>
								<div class="tooltip-error" v-if="err.msg_msg">
									<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
									{{ err.msg_msg }}
								</div>
							</div>
						</div>

						<div class="form-group">
							<div class="col-sm-offset-9 col-sm-3" style="padding: 0 15px;">
								<input type="submit" class="btn btn-black btn-lg" value="Enviar"/>
							</div>
						</div>
					</form>
				</div>
			</section>
		</div>
	</div>
</template>

<style scoped>
	iframe{
		width: 100%;
		height: 400px;
	}
	.col-sm-3, .col-sm-8{
		padding: 0;
	}
	.form-horizontal{
		padding: 0;
	}
	textarea{
		margin-left: 15px;
	}
</style>

<script>
import API from '../store/api';

var form = {
	name: '',
	email: '',
	msg: '',
	subject: '',
	phone: ''
};

var string_regexp = new RegExp(/[^\s0-9]+(\s+[^\s]+)*$/);
var alphanumeric_regexp = new RegExp(/[^\s#°]+(\s+[^\s]+)*$/);
var email_regexp = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);

export default {
	// ------ DATA ------

	data() {
		return {
			form: form,
			has_error: false,
			err_msg: '',
			err: {}
		};
	},

	// ------ VUEX ------

	vuex: {
		actions: {
			//contactForm
		}
	},

	// ------ METHODS ------

	methods: {
		contactForm(e) {

		},

		validateContact() {
			for (var k in this.form) {
				if (!this.form[k]) {
					this.has_error = true;
					this.err[k] = true;
				}
			}

			if (!this.form.name.match(string_regexp) && !this.err.name) {
				this.err_msg.name = 'Ingresa únicamente letras para continuar.';
			}

			if (!this.form.email.match(email_regexp) && !this.err.email){
				this.err.email_msg = 'Ingresa un email válido para continuar.';
			}

			if (this.form.msg.length < 11 && !this.err.msg) {
				this.err.msg_msg = 'El mensaje debe tener al menos 10 caracteres.';
			}
		},

		sendEmailContact (e) {
			e.preventDefault();
			this.has_error = false;
			this.error_msg = '';
			this.err = {};

			// Fix the tooltip for xs and sm screens.
			setTimeout( function(){
				$(".tooltip-error").css({"position": "initial", "margin-top" : "20px"});
				$(".tooltip-error").addClass("center-block");
				$(".top-caret").css("display", "none");
			}, 10);

			this.validateContact();

			if (this.has_error) {
				return;
			}

			API.Contact.send(this.form);
			e.target.reset();
		},

		getSubject () {
			let subject = this.$route.query.subject;

			if (subject)
				// Get the subject from the query route.
				this.form.subject = subject;
		}
	},

	// ------ READY ------

	ready() {
		this.getSubject();
	}
}
</script>



// WEBPACK FOOTER //
// Contact.vue?0ec0b51b